/**
 * @generated SignedSource<<cf3a822b1ed9405d05bbe12ae4fdf218>>
 * @relayHash 0f003d9fd60e6ab67e977d28a1806ad1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0f003d9fd60e6ab67e977d28a1806ad1

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteMeasRadiologyPrescriptionInput = {
  id: string;
};
export type useChDeleteRadiologyPrescriptionMutation$variables = {
  input: Ch_deleteMeasRadiologyPrescriptionInput;
};
export type useChDeleteRadiologyPrescriptionMutation$data = {
  readonly ch_deleteMeasRadiologyPrescription: {
    readonly ch_MeasRadiologyPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteRadiologyPrescriptionMutation = {
  response: useChDeleteRadiologyPrescriptionMutation$data;
  variables: useChDeleteRadiologyPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteRadiologyPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteMeasRadiologyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteMeasRadiologyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasRadiologyPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasRadiologyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteRadiologyPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteMeasRadiologyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteMeasRadiologyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasRadiologyPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasRadiologyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0f003d9fd60e6ab67e977d28a1806ad1",
    "metadata": {},
    "name": "useChDeleteRadiologyPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9e92007c0ebf57c5235b0d8f67121e86";

export default node;
